import { Issue } from "generated-graphql/graphql";

import { DocumentOption } from "./types";

// Maps an issue's generic key (after translateToGenericIssues) to the radio
// option whose detail step would resolve it.
const ISSUE_KEY_TO_OPTION: Record<string, DocumentOption> = {
  documentIds: DocumentOption.Upload,
  facilityDocuments: DocumentOption.Upload,
  publicInternetURL: DocumentOption.PublicInternetURL,
  providedToRegulator: DocumentOption.ProvidedToRegulator,
  suppliedIn: DocumentOption.ProvideElsewhere,
  suppliedInExplanation: DocumentOption.ProvideElsewhere,
  exemptExplanation: DocumentOption.Exempt,
  storedAtFacilityCersId: DocumentOption.StoredAtFacility,
};

// Validator output for the Upload step uses array paths
// (`upload.<index>.document.<field>`) that don't match the exact-key table.
// Match those via prefix.
const ISSUE_KEY_PREFIX_TO_OPTION: { prefix: string; option: DocumentOption }[] = [
  { prefix: "upload.", option: DocumentOption.Upload },
];

// Issue keys that target the radio group itself rather than any specific
// option — rendered above the radios instead of under them.
const TOP_BANNER_KEYS = new Set<string>(["documentOption"]);

function optionForIssue(issue: Issue): DocumentOption | undefined {
  if (!issue.key) return undefined;
  const exact = ISSUE_KEY_TO_OPTION[issue.key];
  if (exact) return exact;
  const prefixed = ISSUE_KEY_PREFIX_TO_OPTION.find((entry) => issue.key?.startsWith(entry.prefix));
  return prefixed?.option;
}

export function groupIssuesByOption(issues: Issue[]): Map<DocumentOption, Issue[]> {
  const grouped = new Map<DocumentOption, Issue[]>();
  for (const issue of issues) {
    const option = optionForIssue(issue);
    if (!option) continue;
    const existing = grouped.get(option) ?? [];
    existing.push(issue);
    grouped.set(option, existing);
  }
  return grouped;
}

export function getTopBannerIssues(issues: Issue[]): Issue[] {
  return issues.filter((issue) => issue.key != null && TOP_BANNER_KEYS.has(issue.key));
}
